import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  icon: React.ReactNode
  name?: string
  className?: string
}

export function BlockchainView({ icon, name, className }: Props) {
  return (
    <div className={cn("flex items-center gap-2 text-sm", className)}>
      <div className="blockchain-icon relative h-5 w-5">{icon}</div>
      {name && <span className="blockchain-name">{name}</span>}
    </div>
  )
}
